import React, { Component, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Loader from "../../../../component/loader";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import { Grid, Paper } from "@mui/material";
import Breadcrumb from "../../../../component/breadcrumb";
import NewCartBlock from "../review/newCartBlock";
import Button from "../../../../component/button";
import CustomerDetailBlock from "../review/customerDetailsBlock";
import Input from "../../../../component/inputpm";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import {
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import { Tooltip } from "@mui/material";
import OrderActionDialog from "../../order/orderActionDialog";
import {
  CancelIcon,
  ClearIcon,
  DiagramIcon,
  RefreshIcon,
  ViewIconNew,
  PlusIcon,
} from "../../../../component/icons/icons";
import { value } from "jsonpath";
import EditIcon from "@mui/icons-material/Edit";
import ClearIconMUI from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import ManageCustomersHierarchy from "../../manageCustomers/manageCustomersHierarchy";
import Card from "@mui/material/Card";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "../../../../asset/images/info.svg";
import Chip from "@mui/material/Chip";
import TableContainer from "@mui/material/TableContainer";
import CancelOrderDialog from "../../order/cancelOrderDialog";
import InputPhone from "../../../../component/inputPhone";
import { FormHelperText } from "@mui/material";
import { getStatesList, getStateName } from "../../../../helper/getStateList";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../../helper/withNavigation";
import formatDate from "../../../../helper/dateFormatter";

class VerifyQuote extends Component {
  state = {
    loading: true,
    bread: [],
    id: "",
    quoteData: {},
    render: false,
    showActionButtons: true,
    customerDetails: {},
    notes: "",
    comments: [],
    shipmentMethodTypeId: "ST_OVERNIGHT | FEDEX",
    shipmentMethodTypeList: [
      {
        name: "Federal Express - Standard Overnight",
        value: "ST_OVERNIGHT | FEDEX",
      },
    ],
    priceRecuringChargeTotal: [{}],
    priceRecurringCharge: [{}],
    quoteType: "",
    showClearWarning: false,
    quoteHistory: [],
    formFields: {},
    actionDialog: false,
    processInstanceDiagram: null,
    bpmnProcessInstanceId: null,
    workFlowEnabled: false,
    isEligibleUser: false,
    renderCartBlock: true,
    editItems: {},
    removeItemWrning: false,
    itemToRemove: {},
    eligibleRole: "",
    is_order_status: false,
    order_status_details: {},
    toggelSubscriptionIdDialog: false,
    discountPercentage: 0,
    showBanDialog: false,
    custCodeValue: "",
    showCustomerBanError: false,
    isCancelQuote: false,
    unsavedChanges: false,
    leadCustomerDetails: {},
    error: {},
    statesList: [],
  };
  componentDidMount() {
    let search = new URLSearchParams(this.props.router.location.search);
    let quoteId = "";
    if (this.props.router.params.id) {
      quoteId = this.props.router.params.id;
    } else {
      quoteId = search.get("quoteId");
    }
    this.setState(
      {
        id: quoteId,
      },
      () => {
        this.getQuoteData(quoteId);
      },
    );
  }
  getQuoteData = (id) => {
    this.setState({
      isEligibleUser: false,
      eligibleRole: "",
      unsavedChanges: false,
    });
    BusApiCall("GET", `${constants.busV44UrlPublic}/quote/${id}`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          var tempCartData = res.data[0];
          var quoteStatus = tempCartData.quoteStatus;
          var reduxQuoteId = "";
          if (
            this.props.shoppingQuote &&
            this.props.shoppingQuote.length > 0 &&
            this.props.shoppingQuote[0].cartItem &&
            this.props.shoppingQuote[0].cartItem.length > 0
          ) {
            reduxQuoteId = this.props.shoppingQuote[0].id;
          }
          if (
            reduxQuoteId &&
            tempCartData.type === "NewActivation" &&
            quoteStatus === "QUO_ORDERED" &&
            reduxQuoteId === tempCartData.id
          ) {
            this.props.setQuote([]);
          }
          this.setState(
            {
              discountPercentage: tempCartData.discountPercentage
                ? tempCartData.discountPercentage
                : 0,
              workFlowEnabled: tempCartData.workFlowEnabled
                ? tempCartData.workFlowEnabled
                : false,
              processInstanceDiagram: tempCartData.processInstanceDiagram,
              bpmnProcessInstanceId: tempCartData.bpmnProcessInstanceId,
            },
            () => {
              if (this.state.workFlowEnabled && quoteStatus !== "QUO_ORDERED") {
                this.getBPMNActions();
              }
            },
          );
          var quoteType = tempCartData.type;
          if (
            quoteStatus !== "QUO_APPROVED" &&
            quoteStatus !== "QUO_ORDERED" &&
            quoteStatus !== "QUO_REVIEW" &&
            quoteStatus !== "QUO_WAIT_ORDER"
          ) {
            this.setState({
              editItems: {
                discount: true,
                quantity: true,
                remove: true,
                location: quoteType === "ShiftSubscription" ? true : false,
              },
            });
          }
          if (this.props.router.location.pathname.includes('/quote/')) {
            this.setState({
              bread: [
                { title: `${this.props.t("QUOTES")}`, url: "/quotes" },
                { title: `${this.state.id}`, url: `/quote/${this.state.id}` },
              ],
              quoteType,
            });
          } else {
            this.setState({
              bread: [
                {
                  title: `${this.props.t("VERIFY_QUOTE")} #${this.state.id}`,
                  url: "/verifyQuote",
                },
              ],
              quoteType,
            });
          }
          if (
            tempCartData &&
            tempCartData.cartItem &&
            tempCartData.cartItem.length > 0
          ) {
            for (var i = 0; i < tempCartData.cartItem.length; i++) {
              if (
                tempCartData.cartItem[i].productOffering.includedItems &&
                tempCartData.cartItem[i].productOffering.includedItems.length >
                0
              ) {
                for (
                  var j = 0;
                  j <
                  tempCartData.cartItem[i].productOffering.includedItems.length;
                  j++
                ) {
                  if (
                    !tempCartData.cartItem[i].productOffering.includedItems[j]
                      .customerViewable
                  ) {
                    var viewableIndex = tempCartData.cartItem[
                      i
                    ].productOffering.includedItems.findIndex(
                      (x) => x.customerViewable,
                    );
                    if (viewableIndex > -1) {
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          viewableIndex
                        ].alreadyAdded
                      ) {
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].priceType === "RC"
                        ) {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].alreadyAdded = true;
                          var viewableItem =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex];
                          if (viewableItem.priceTerm) {
                            var key = `${viewableItem.priceTerm.termPeriod}_${viewableItem.priceTerm.termUomId}`;
                            var found = false;
                            var updatedList = viewableItem.recurringCost
                              ? [...viewableItem.recurringCost]
                              : [];
                            for (var k = 0; k < updatedList.length; k++) {
                              if (updatedList[k].key === key) {
                                updatedList[k].price += viewableItem.price;
                                found = true;
                                break;
                              }
                            }

                            if (!found) {
                              var newObj = {
                                key: key,
                                termPeriod: viewableItem.priceTerm.termPeriod,
                                tenureUom: viewableItem.priceTerm.termUomId,
                                price: viewableItem.price,
                              };
                              updatedList.push(newObj);
                            }
                            this.setState({
                              priceRecurringCharge: updatedList,
                            });
                            viewableItem.recurringCost = updatedList;
                          }
                          // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // } else {
                          //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].price;
                          // }
                        } else {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].alreadyAdded = true;
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost
                          ) {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].nonRecurringCost +
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].price;
                          } else {
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[
                              viewableIndex
                            ].nonRecurringCost =
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].price;
                          }
                        }
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices &&
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].otherPrices.length > 0
                        ) {
                          for (
                            var k = 0;
                            k <
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].otherPrices.length;
                            k++
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "DEPOSIT"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].depositPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[j].otherPrices[k].price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].depositPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "USAGE_CHARGE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].usageCharge +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].usageCharge =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "SETUP_FEE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].setupFee +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].setupFee =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "CANCELLATION_PRICE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex]
                                    .cancellationPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].cancellationPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].otherPrices[k]
                                .priceType === "SHIFT_PRICE"
                            ) {
                              if (
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].shiftPrice
                              ) {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].shiftPrice =
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].shiftPrice +
                                  tempCartData.cartItem[i].productOffering
                                    .includedItems[viewableIndex].otherPrices[k]
                                    .price;
                              } else {
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[
                                  viewableIndex
                                ].shiftPrice =
                                  tempCartData.cartItem[
                                    i
                                  ].productOffering.includedItems[
                                    viewableIndex
                                  ].otherPrices[k].price;
                              }
                            }
                          }
                        }
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].priceType === "RC"
                      ) {
                        var viewableItem =
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex];
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].priceTerm
                        ) {
                          var key = `${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termPeriod}_${tempCartData.cartItem[i].productOffering.includedItems[j].priceTerm.termUomId}`;
                          var found = false;
                          var updatedList = viewableItem.recurringCost
                            ? [...viewableItem.recurringCost]
                            : [];

                          for (var k = 0; k < updatedList.length; k++) {
                            if (updatedList[k].key === key) {
                              updatedList[k].price +=
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].price;
                              found = true;
                              break;
                            }
                          }

                          if (!found) {
                            var newObj = {
                              key: key,
                              termPeriod:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termPeriod,
                              tenureUom:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].priceTerm.termUomId,
                              price:
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].price,
                            };
                            updatedList.push(newObj);
                          }

                          this.setState({ priceRecurringCharge: updatedList });
                          viewableItem.recurringCost = updatedList;
                        }
                        // if (tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost) {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost + tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // } else {
                        //     tempCartData.cartItem[i].productOffering.includedItems[viewableIndex].recurringCost = tempCartData.cartItem[i].productOffering.includedItems[j].price;
                        // }
                      } else {
                        if (
                          tempCartData.cartItem[i].productOffering
                            .includedItems[viewableIndex].nonRecurringCost
                        ) {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[i].productOffering
                              .includedItems[viewableIndex].nonRecurringCost +
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].price;
                        } else {
                          tempCartData.cartItem[
                            i
                          ].productOffering.includedItems[
                            viewableIndex
                          ].nonRecurringCost =
                            tempCartData.cartItem[
                              i
                            ].productOffering.includedItems[j].price;
                        }
                      }
                      if (
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices &&
                        tempCartData.cartItem[i].productOffering.includedItems[
                          j
                        ].otherPrices.length > 0
                      ) {
                        for (
                          var k = 0;
                          k <
                          tempCartData.cartItem[i].productOffering
                            .includedItems[j].otherPrices.length;
                          k++
                        ) {
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "DEPOSIT"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].depositPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].depositPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].depositPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "USAGE_CHARGE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].usageCharge
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].usageCharge +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].usageCharge =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "SETUP_FEE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].setupFee
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].setupFee +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].setupFee =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "CANCELLATION_PRICE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].cancellationPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex]
                                  .cancellationPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].cancellationPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                          if (
                            tempCartData.cartItem[i].productOffering
                              .includedItems[j].otherPrices[k].priceType ===
                            "SHIFT_PRICE"
                          ) {
                            if (
                              tempCartData.cartItem[i].productOffering
                                .includedItems[viewableIndex].shiftPrice
                            ) {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].shiftPrice =
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[viewableIndex].shiftPrice +
                                tempCartData.cartItem[i].productOffering
                                  .includedItems[j].otherPrices[k].price;
                            } else {
                              tempCartData.cartItem[
                                i
                              ].productOffering.includedItems[
                                viewableIndex
                              ].shiftPrice =
                                tempCartData.cartItem[
                                  i
                                ].productOffering.includedItems[j].otherPrices[
                                  k
                                ].price;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            // var bread = [{ title: this.props.t('QUOTE') + ' #' + tempCartData.id, url: "/quote" }];
            // this.setState({
            //     bread: bread
            // })
            // this.setState({ loading: false, cartData: [tempCartData] });
            // this.props.setQuote(res.data);
            // if (res.data && res.data.length > 0) {
            //     this.setState({
            //         disableCheckout: false
            //     })
            // }
          }
          if (tempCartData.customer.isTempCustCode) {
            this.getLeadProfileDetails(tempCartData.customer.clientId);
          }
          this.setState(
            {
              quoteData: [tempCartData],
              customerDetails: tempCartData.customer,
              comments: tempCartData.comments,
              quoteHistory: tempCartData.history,
              loading: false,
              render: true,
              showActionButtons:
                tempCartData.quoteStatus === "QUO_REVIEW" ? true : false,
              renderCartBlock: false,
            },
            () => {
              this.setState({
                renderCartBlock: true,
              });
            },
          );
          this.setState({ loading: false });
        } else {
          this.props.setErrorMessage(this.props.t("QUOTE_NOT_FOUND"), false);
          this.setState({
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };
  getLeadProfileDetails = (id) => {
    BusApiCall("GET", `${constants.busV4Url}/myProfile?customerId=${id}`).then(
      (res) => {
        var tempCustomer = res.data;
        var customer = {
          contact: {
            firstName: tempCustomer.firstName ? tempCustomer.firstName : "",
            lastName: tempCustomer.lastName ? tempCustomer.lastName : "",
            partyId: tempCustomer.partyId ? tempCustomer.partyId : "",
            officePhone: tempCustomer.officePhone
              ? tempCustomer.officePhone
              : "",
            mobilePhone: tempCustomer.mobilePhone
              ? tempCustomer.mobilePhone
              : "",
            email: tempCustomer.email ? tempCustomer.email : "",
            emailMechId: tempCustomer.emailMechId
              ? tempCustomer.emailMechId
              : "",
            mobilePhoneMechId: tempCustomer.mobilePhoneMechId
              ? tempCustomer.mobilePhoneMechId
              : "",
            billingCloseDay: tempCustomer.billingCloseDay
              ? tempCustomer.billingCloseDay
              : "",
            createdByUser: tempCustomer.createdByUser
              ? tempCustomer.createdByUser
              : "",
          },
          billing: {
            attention: "",
            phone: "",
            street1: "",
            street2: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
          shipping: {
            attention:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].attention
                ? tempCustomer.shipping[0].attention
                : "",
            phone:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].phone
                ? tempCustomer.shipping[0].phone
                : "",
            phoneMechId:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].phoneMechId
                ? tempCustomer.shipping[0].phoneMechId
                : "",
            street1:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].street1
                ? tempCustomer.shipping[0].street1
                : "",
            street2:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].street2
                ? tempCustomer.shipping[0].street2
                : "",
            city:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].city
                ? tempCustomer.shipping[0].city
                : "",
            state:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].state
                ? tempCustomer.shipping[0].state
                : "",
            zip:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].zip
                ? tempCustomer.shipping[0].zip
                : "",
            country:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].country
                ? tempCustomer.shipping[0].country
                : this.props.defaultCountry,
            postalMechId:
              tempCustomer.shipping &&
                tempCustomer.shipping.length > 0 &&
                tempCustomer.shipping[0].postalMechId
                ? tempCustomer.shipping[0].postalMechId
                : "",
          },
          banDetails: {
            accountName: tempCustomer.accountName
              ? tempCustomer.accountName
              : "",
            ban: "",
            isManaged: false,
          },
        };
        this.setStateListChange(customer.shipping.country);
        this.setState({
          leadCustomerDetails: customer,
        });
      },
    );
  };
  verifyQuote = (status) => {
    this.setState({
      loading: true,
    });
    var payload = {
      statusId: status,
      note: {
        text: this.state.notes,
      },
    };
    BusApiCall(
      "PUT",
      `${constants.busV44UrlPublic}/quote/${this.state.id}/updateStatus`,
      payload,
    )
      .then((res) => {
        this.props.setErrorMessage(
          status === "QUO_APPROVED"
            ? this.props.t("QUOTE_APPROVED")
            : status === "QUO_REJECTED"
              ? this.props.t("QUOTE_REJECTED")
              : this.props.t("QUOTE_STATUS_UPDATED"),
          true,
        );
        this.setState({
          loading: false,
          showActionButtons: false,
          notes: "",
        });
        this.getQuoteData(this.state.id);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };
  changeNotes = (e) => {
    this.props.setErrorMessage("", false);
    if (e.target.value.length < 2001) {
      this.setState({
        notes: e.target.value,
      });
    } else {
      this.props.setErrorMessage(this.props.t("MAX_2000_CHARACTER_ERROR"));
    }
  };

  setShipmentMethodTypeId = (e) => {
    this.setState({
      shipmentMethodTypeId: e.target.value,
    });
  };
  confirmQuote = (note) => {
    if (!this.state.notes) {
      this.props.setErrorMessage(this.props.t("NO_NOTE_ADDED"), false);
    } else {
      this.setState({
        loading: true,
      });
      var payload = {
        // statusId: 'QUO_REVIEW',
        note: {
          text: this.state.notes,
        },
      };
      if (
        this.state.quoteData &&
        this.state.quoteData.length > 0 &&
        this.state.quoteData[0].id
      ) {
        BusApiCall(
          "PUT",
          `${constants.busV44UrlPublic}/quote/${this.state.quoteData[0].id}/updateStatus`,
          payload,
        )
          .then((res) => {
            if (note) {
              this.props.setErrorMessage(
                this.props.t("NOTE_ADDED_SUCCESSFULLY"),
                true,
              );
            } else {
              this.props.setErrorMessage(
                this.props.t("QUOTE_DATA_UPDATED"),
                true,
              );
            }
            this.setState({
              notes: "",
            });
            this.getQuoteData(this.state.id);
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };
  createOrder = () => {
    let paymentMethodId = null;
    if (
      this.state.customerDetails.paymentMethod &&
      this.state.customerDetails.paymentMethod.creditCards &&
      this.state.customerDetails.paymentMethod.creditCards.length > 0
    ) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.creditCards[0].paymentMethodId;
    } else if (
      this.state.customerDetails.paymentMethod &&
      this.state.customerDetails.paymentMethod.eftAccount &&
      this.state.customerDetails.paymentMethod.eftAccount.length > 0
    ) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.eftAccount[0].paymentMethodId;
    } else if (this.state.customerDetails.paymentMethod) {
      paymentMethodId =
        this.state.customerDetails.paymentMethod.paymentMethodId;
    }
    var payload = {
      action: "CREATE_ORDER",
      userData: [
        {
          name: "PORTAL_SEND_TNC_EMAIL",
          value:
            this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
              this.props.loggedInUserType === "ECOMMERCE_ADMIN"
              ? "false"
              : "true",
        },
        {
          name: "ORDER_ORIGINATOR",
          value: "Portal",
        },
        {
          name: "ORDER_CREATED_BY",
          value: this.props.providerType,
        },
        {
          name: "shipmentMethodTypeId",
          value: this.state.shipmentMethodTypeId.split("|")[0].trim(),
        },
        {
          name: "carrierPartyId",
          value: this.state.shipmentMethodTypeId.split("|")[1].trim(),
        },
      ],
      agentCode: "",
      note: [
        {
          text: this.state.notes,
        },
      ],
      relatedParty: [
        {
          id: this.state.customerDetails.ban + "",
          role: this.state.customerDetails.role,
        },
      ],
    };
    if (
      this.state.customerDetails.billing &&
      this.state.customerDetails.billing.postalMechId
    ) {
      payload.billingContactMechId =
        this.state.customerDetails.billing.postalMechId;
    } else {
      payload.billingContactMechId = "";
    }
    if (
      this.state.customerDetails.shipping &&
      this.state.customerDetails.shipping.postalMechId
    ) {
      payload.shippingContactMechId =
        this.state.customerDetails.shipping.postalMechId;
    } else {
      payload.shippingContactMechId = "";
    }

    if (paymentMethodId) {
      payload.payment = [
        {
          id: paymentMethodId,
        },
      ];
    } else {
      payload.payment = [];
    }
    this.setState({
      loading: true,
    });
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/quote/${this.state.quoteData[0].id}`,
      payload,
    )
      .then((res) => {
        this.setState({
          loading: false,
        });
        if (res.data.orderId) {
          this.props.router.navigate("/order/" + res.data.orderId);
        }
        this.props.setErrorMessage(
          this.props.t("ORDER_INITIATED_FOR_QUOTE"),
          true,
        );
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  showClearCartWarning = () => {
    this.setState({
      showClearWarning: !this.state.showClearWarning,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  clearQuoteData = () => {
    this.setState({
      loading: true,
    });
    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    var url = `${constants.busV44UrlPublic}/quote/${this.state.id}`;
    BusApiCall("DELETE", url, jsonData)
      .then((res) => {
        this.setState({ loading: false, showClearWarning: false });
        this.props.setErrorMessage(this.props.t("QUOTE_CLEARED"), true);
        this.props.router.navigate("/quotes");
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          showClearWarning: false,
          disableCheckout: false,
        });
      });
  };

  getBPMNActions = () => {
    let search = new URLSearchParams(this.props.router.location.search);
    let tenantId = search.get("tenantId");
    let data = {};
    if (tenantId) {
      data = {
        tenantId: tenantId,
      };
    }
    // Get order actions from flowable
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/quotes/${this.state.id}/flowable/bpmn/taskForms`,
      data,
    )
      .then((res) => {
        var is_order_status =
          res.data.is_order_status &&
            (res.data.is_order_status === true ||
              res.data.is_order_status === "true")
            ? true
            : false;
        if (is_order_status) {
          this.setState({
            order_status_details: res.data.order_status_details,
          });
        }
        var formFields = res.data;
        if (formFields.fields && formFields.fields.length > 0) {
          for (var i = 0; i < formFields.fields.length; i++) {
            if (formFields.fields[i].value) {
              formFields.fields[i].value = null;
            }
          }
        }
        this.setState(
          {
            formFields: formFields,
            is_order_status: is_order_status,
          },
          () => {
            this.checkisEligibleUser();
          },
        );
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  showActionDialog = () => {
    if (
      this.state.quoteData[0].quoteStatus === "QUO_WAIT_ORDER" &&
      this.state.customerDetails.isTempCustCode
    ) {
      console.log(
        "check final val",
        this.state.customerDetails,
        this.state.quoteData[0].quoteStatus,
      );
      this.setState({
        showBanDialog: true,
      });
    } else {
      this.setState(
        {
          actionDialog: true,
        },
        () => { },
      );
    }
  };

  closeBanDialog = () => {
    this.setState({
      showCustomerBanError: false,
      showBanDialog: false,
    });
  };

  createCustomerBan = () => {
    if (this.state.leadCustomerDetails.banDetails.ban.trim() === "") {
      var error = {};
      error.ban = this.props.t("ACCOUNT_NUMBER_IS_REQUIRED");
      this.setState({
        error,
      });
      return;
    } else if (
      this.state.customerDetails.tempCustCodePrefix &&
      this.state.leadCustomerDetails.banDetails.ban
        .toLowerCase()
        .startsWith(this.state.customerDetails.tempCustCodePrefix.toLowerCase())
    ) {
      this.setState({
        showCustomerBanError: true,
      });
      return;
    }
    if (this.state.leadCustomerDetails.banDetails.ban.trim()) {
      this.setState({ loading: true });
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/customers/${this.state.leadCustomerDetails.banDetails.ban}/validate`,
        {},
      )
        .then((res) => {
          console.log("check ban verify", res.data);
          if (res && res.data) {
            if (res.data.apiEnabled === "Y") {
              if (
                // res.data.code === 200 &&
                (res.data.status === "Active" ||
                  res.data.status === "Qualified")
              ) {
                // Allow to create
                this.submitCustomerBan();
                // this.setState({
                //     showBanDialog: false,
                // })
              } else {
                // not allowed
                this.props.setErrorMessage(
                  this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
                  false,
                );
                this.setState({
                  showBanDialog: false,
                  loading: false,
                  custCodeValue: "",
                });
              }
            } else {
              // Allow to create
              this.submitCustomerBan();
              // this.setState({
              //     showBanDialog: false
              // })
            }
          } else {
            // not allowed
            this.props.setErrorMessage(
              this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
              false,
            );
            this.setState({
              showBanDialog: false,
              loading: false,
              custCodeValue: "",
            });
          }
        })
        .catch((err) => {
          // not allowed
          // this.props.setErrorMessage(this.props.t('BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER'), false);
          var msg = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
          this.props.setErrorMessage(msg, false);
          this.setState({
            showBanDialog: false,
            loading: false,
            custCodeValue: "",
          });
        });
    }
  };

  submitCustomerBan = () => {
    const t = this.props.t;
    var error = {};
    if (!this.state.leadCustomerDetails.banDetails.ban) {
      error.ban = this.props.t("ACCOUNT_NUMBER_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.banDetails.accountName) {
      error.accountName = this.props.t("ACCOUNT_NAME_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.contact.email) {
      error.email = t("EMAIL_IS_REQUIRED");
    } else if (
      !/\S+@\S+\.\S+/.test(this.state.leadCustomerDetails.contact.email)
    ) {
      error.email = t("EMAIL_IS_INVALID");
    }
    if (!this.state.leadCustomerDetails.shipping.attention) {
      error.attention = t("ATTENTION_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.shipping.street1) {
      error.street1 = t("STREET1_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.shipping.city) {
      error.city = t("CITY_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.shipping.state) {
      error.state = t("STATE_IS_REQUIRED");
    }
    if (!this.state.leadCustomerDetails.shipping.country) {
      error.country = t("COUNTRY_IS_REQUIRED");
    }
    if (Object.keys(error).length === 0) {
      this.setState({ error: {} });
    } else {
      this.setState({ error, loading: false });
      return true;
    }
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/customers/${this.state.leadCustomerDetails.banDetails.ban}/client/${this.state.customerDetails.clientId}/updateCustomerBAN`,
    )
      .then((res) => {
        console.log("check ban", res.data);
        var payload = this.state.leadCustomerDetails;
        // payload.banDetails.ban = res.data.ban;
        BusApiCall("POST", `${constants.busInternalUrl}/customers`, payload)
          .then((res) => {
            if (res.data.responseMessage === "success") {
              this.setState({
                leadCustomerDetails: {},
                showBanDialog: false,
              });
              this.getQuoteData(this.state.id);
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
        // this.getQuoteData(this.state.id);
        // this.setState({
        //     custCodeValue: '',
        // })
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // onChangeBanDetails = (e) => {
  //     this.setState({
  //         showCustomerBanError: false,
  //         [e.target.name]: e.target.value
  //     })
  // }

  closeActionDialog = (val) => {
    if (val) {
      this.setState({
        loading: true,
      });
      let search = new URLSearchParams(this.props.router.location.search);
      let tenantId = search.get("tenantId");
      val.properties.push({
        id: "accessToken",
        value: this.props.accessToken,
      });
      val.properties.push({
        id: "customerBan",
        value: this.state.customerDetails.ban,
      });
      if (val.uploadedFilesData && val.uploadedFilesData.length > 0) {
        var uploadedFilesData = [];
        for (var i = 0; i < val.uploadedFilesData.length; i++) {
          var fileItem = {
            document: [
              {
                id: "upload",
                value: val.uploadedFilesData[i].fileData,
              },
              {
                id: "uploadedFileName",
                value: val.uploadedFilesData[i].uploadedFileName,
              },
              {
                id: "uploadedFileMimeType",
                value: val.uploadedFilesData[i].uploadedFileMimeType,
              },
              {
                id: "uploadedFileTaskId",
                value: val.uploadedFilesData[i].uploadedFileTaskId,
              },
              {
                id: "isPublic",
                value: val.uploadedFilesData[i].isPublic ? "Y" : "N",
              },
            ],
          };
          uploadedFilesData.push(fileItem);
          if (i === val.uploadedFilesData.length - 1) {
            val.properties.push({
              id: "uploadedFiles",
              value: JSON.stringify(uploadedFilesData),
            });
          }
        }
      }
      // for (var i = 0; i < val.properties.length; i++) {
      //     if (val.properties[i].fileData) {
      //         val.properties[i].value = val.properties[i].fileData;
      //         delete val.properties[i].fileData;
      //     }
      // }
      if (this.state.is_order_status) {
        var payload = {};
        payload = val;
        if (tenantId) {
          payload.tenantId = tenantId;
        }
        // payload = {
        //     [val.properties[0].id]: val.properties[0].value
        // }
        console.log("final payload", payload);
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/resumeDeadProcess?processInstanceId=${this.state.formFields.processInstanceId}`,
          payload,
        )
          .then((res) => {
            this.props.setErrorMessage(
              this.props.t("QUOTE_DATA_UPDATED"),
              true,
            );
            this.setState(
              {
                actionDialog: false,
                // loading: false
              },
              () => {
                this.getQuoteData(this.state.id);
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      } else {
        var payload = {};
        payload = val;
        if (tenantId) {
          val.tenantId = tenantId;
        }
        payload.properties.push(
          {
            id: "userLoginId",
            value: this.props.loggedInUserId,
          },
          {
            id: "userLoginName",
            value: this.props.loggedInUserName
              ? this.props.loggedInUserName
              : this.props.providerName,
          },
        );
        delete payload.uploadedFilesData;
        var uploadIndex = payload.properties.findIndex(
          (x) => x.id === "upload",
        );
        if (uploadIndex > -1) {
          payload.properties.splice(uploadIndex, 1);
        }
        console.log("final payload", payload);
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/taskForms`,
          payload,
        )
          .then((res) => {
            this.props.setErrorMessage(
              this.props.t("QUOTE_DATA_UPDATED"),
              true,
            );
            if (this.state.notes) {
              this.confirmQuote();
            } else {
              this.setState(
                {
                  actionDialog: false,
                  // loading: false
                },
                () => {
                  this.getQuoteData(this.state.id);
                },
              );
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      }
    } else {
      this.setState({
        actionDialog: false,
      });
    }
  };

  openDiagramDialog = () => {
    window.open(
      `${window.location.origin}/diagram.html?baseUrl=${constants.busV44UrlPublic}&bpmnProcessInstanceId=${this.state.bpmnProcessInstanceId}&quoteId=${this.state.id}&type=quote`,
      "_blank",
    );
  };

  getExtension = () => {
    var extension = "";
    let decoded = atob(this.state.processInstanceDiagram);
    var lowerCase = decoded.toLowerCase();
    if (lowerCase.indexOf("png") === 1) {
      extension = "png";
    } else if (
      lowerCase.indexOf("jpg") === 1 ||
      lowerCase.indexOf("jpeg") === 1
    ) {
      extension = "jpg";
    } else if (lowerCase.includes("svg")) {
      extension = "svg+xml";
    } else if (
      lowerCase.indexOf("tif") === 1 ||
      lowerCase.indexOf("tiff") === 1
    ) {
      extension = "tiff";
    }
    return extension;
  };

  checkisEligibleUser = () => {
    var securityGroupsList = this.props.securityGroupsList;
    var groupList = this.state.formFields.identityLinks;
    if (groupList && groupList.length > 0) {
      var isUserApplicable = groupList.some((g) => g.user);
      if (isUserApplicable) {
        this.setState({
          isEligibleUser: true,
          eligibleRole: "",
        });
        return;
      }
      if (securityGroupsList.includes("ADMIN")) {
        this.setState({
          isEligibleUser: true,
        });
        if (groupList && groupList.length > 0) {
          if (groupList.length === 1) {
            if (groupList[0].group) {
              this.snakeToSentenceCase(groupList[0].group);
            }
          } else {
            for (var i = 0; i < groupList.length; i++) {
              if (groupList[i].group !== "ADMIN") {
                if (groupList[i].group) {
                  this.snakeToSentenceCase(groupList[i].group);
                }
                return;
              }
            }
          }
        }
      } else {
        if (groupList && groupList.length > 0) {
          if (groupList.length === 1) {
            if (groupList[0].group) {
              this.snakeToSentenceCase(groupList[0].group);
            }
            var index = securityGroupsList.findIndex(
              (x) => x === groupList[0].group,
            );
            if (index > -1) {
              this.setState({
                isEligibleUser: true,
              });
              return;
            } else {
              this.setState({
                isEligibleUser: false,
              });
              return;
            }
          } else {
            for (var i = 0; i < groupList.length; i++) {
              if (groupList[i].group !== "ADMIN") {
                if (groupList[i].group) {
                  this.snakeToSentenceCase(groupList[i].group);
                }
                return;
              }
            }
            for (var i = 0; i < groupList.length; i++) {
              var index = securityGroupsList.findIndex(
                (x) => x === groupList[i].group,
              );
              if (index > -1) {
                this.setState({
                  isEligibleUser: true,
                });
                return;
              } else {
                if (index + 1 === groupList.length) {
                  this.setState({
                    isEligibleUser: false,
                  });
                  return;
                }
              }
            }
          }
        } else {
          this.setState({
            isEligibleUser: true,
            eligibleRole: "",
          });
        }
      }
    } else {
      this.setState({
        isEligibleUser: true,
        eligibleRole: "",
      });
    }
  };

  snakeToSentenceCase = (val) => {
    var a = val;
    var b = val.split("_");
    var d = "";
    if (b.length > 1) {
      var c = b.map((x) => x.toLowerCase());
      d = c.join(" ");
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      this.setState({
        eligibleRole: e,
      });
    } else {
      d = val.toLowerCase();
      var e = d.replace(
        /\w\S*/g,
        (text) =>
          text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
      );
      this.setState({
        eligibleRole: e,
      });
    }
  };

  updateLineItemClient = (index, productId, customerId, action) => {
    var payload = [
      {
        packageIndex: index,
        packageProductId: productId,
        location: customerId,
        action: action,
      },
    ];
    this.setState({
      loading: true,
    });
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/quotes/${this.state.id}/locations`,
      payload,
    )
      .then((res) => {
        this.getQuoteData(this.state.id);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  addOfferings = () => {
    var quoteData = this.state.quoteData[0];
    var lastIndex = 0;
    var productCode = "";
    if (quoteData.cartItem && quoteData.cartItem.length > 0) {
      lastIndex = quoteData.cartItem[quoteData.cartItem.length - 1].index + 1;
      productCode = quoteData.cartItem[0].productOffering.id;
    }
    var obj = {
      ban: this.state.customerDetails.ban,
      // partyId: (childItemDetails && childItemDetails.partyId) ? childItemDetails.partyId : customer.partyId,
      partyId: this.state.customerDetails.clientId,
      // customerId: customer.partyId,
      // orderId: item.orderId,
      subscriptionId: this.state.quoteData[0].subscriptionId,
      firstName: this.state.customerDetails.firstName,
      lastName: this.state.customerDetails.lastName,
      // role: customer.role,
      mode: this.state.quoteType,
      productCode: productCode,
      id: this.state.id,
      index: lastIndex,
      oldQuote: true,
      userData: this.state.quoteData[0].userData,
      discountPercentage: this.state.discountPercentage,
    };
    this.props.router.navigate({
      pathname: "/newOrder",
      state: obj,
    });
  };

  tempChangePSQuantity = (e, item) => {
    if (+e.target.value > 0 || e.target.value === "") {
      var oldData = [...this.state.quoteData];
      var cartItem = oldData[0].cartItem;
      var index = cartItem.findIndex((x) => x.id === item.id);

      if (index > -1) {
        oldData[0].cartItem[index].productOffering.quantity = e.target.value;
        this.setState(
          {
            quoteData: oldData,
            unsavedChanges: true,
          },
          () => { },
        );
      }
    } else {
      var oldData = [...this.state.quoteData];
      var cartItem = oldData[0].cartItem;
      var index = cartItem.findIndex((x) => x.id === item.id);

      if (index > -1) {
        oldData[0].cartItem[index].productOffering.quantity = 1;
        this.setState(
          {
            quoteData: oldData,
            unsavedChanges: true,
          },
          () => { },
        );
      }
    }
  };

  tempChangePSQuantityVerify = (e, item) => {
    if (
      item.productOffering.quantity === "" ||
      item.productOffering.quantity === "0"
    ) {
      var oldData = [...this.state.quoteData];
      var cartItem = oldData[0].cartItem;
      var index = cartItem.findIndex((x) => x.id === item.id);

      if (index > -1) {
        oldData[0].cartItem[index].productOffering.quantity = 1;
        this.setState(
          {
            quoteData: oldData,
          },
          () => { },
        );
      }
    } else {
      // this.changePSQuantity(e, item, 'onBlur');
    }
  };

  changePSQuantity = (e, item, blur) => {
    if (e.key === "Enter" && +item.productOffering.quantity > 0) {
      this.updateQuoteData();
    }
  };

  updateQuoteData = () => {
    this.setState({ loading: true });
    console.log("check cart data", this.state.quoteData);
    var payload = {
      quoteItem: [...this.state.quoteData[0].cartItem],
      relatedParty: [
        {
          id: "",
          firstName: "",
          lastName: "",
          role: "",
        },
      ],
    };
    for (var i = 0; i < payload.quoteItem.length; i++) {
      payload.quoteItem[i].productOffering.quantity =
        +payload.quoteItem[i].productOffering.quantity;
      payload.quoteItem[i].action = "MODIFY";
    }
    payload.relatedParty = [
      {
        id: this.state.customerDetails.ban,
        partyId: this.state.quoteData[0].relatedParty[0].id,
        firstName: this.state.quoteData[0].relatedParty[0].firstName,
        lastName: this.state.quoteData[0].relatedParty[0].lastName,
        role: this.state.quoteData[0].relatedParty[0].role
          ? this.state.quoteData[0].relatedParty[0].role
          : "",
      },
    ];
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      payload.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    payload.action = "EDIT_QUOTE";
    payload.discount = this.state.discountPercentage;
    BusApiCall(
      "PATCH",
      `${constants.busV44UrlPublic}/quote/${this.state.quoteData[0].id}`,
      payload,
    )
      .then((res) => {
        this.setState({ loading: false });
        this.getQuoteData(this.state.id);
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  changePSDiscountValue = (e) => {
    if (+e.target.value > -1) {
      // var tempCartData = [];
      // let data = { ...this.state.quoteData[0] }
      // data.discountPercentage = e.target.value
      // tempCartData.push(data);
      this.setState(
        {
          // quoteData: tempCartData,
          discountPercentage: e.target.value,
        },
        () => { },
      );
    }
  };

  changePSDiscount = (e) => {
    if (
      +this.state.discountPercentage >= 0 &&
      +this.state.discountPercentage < 101
    ) {
      this.setState({ loading: true });
      if (
        +this.state.discountPercentage >= 0 ||
        this.state.discountPercentage === ""
      ) {
        var data = {};
        data.quoteItem = this.state.quoteData[0].cartItem;
        for (var i = 0; i < data.quoteItem.length; i++) {
          data.quoteItem[i].action = "MODIFY";
          data.quoteItem[i].productOffering.quantity =
            +data.quoteItem[i].productOffering.quantity;
        }
        data.action = "EDIT_QUOTE";
        data.discount = this.state.discountPercentage;
        data.type = this.state.quoteType;
        data.relatedParty = [
          {
            id: this.state.customerDetails.ban,
            partyId: this.state.quoteData[0].relatedParty[0].id,
            firstName: this.state.quoteData[0].relatedParty[0].firstName,
            lastName: this.state.quoteData[0].relatedParty[0].lastName,
            role: this.state.quoteData[0].relatedParty[0].role
              ? this.state.quoteData[0].relatedParty[0].role
              : "",
          },
        ];
        this.setState({ loading: true });
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/quote/${this.state.quoteData[0].id}`,
          data,
        )
          .then((res) => {
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({ loading: false });
            } else {
              this.props.setQuote(res.data);
              this.getQuoteData(this.state.id);
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
    if (+this.state.discountPercentage < 0) {
      this.props.setErrorMessage(
        this.props.t("NEGATIVE_VALUE_RESTRICTION"),
        false,
      );
      this.setState({ loading: false });
    }
    if (+this.state.discountPercentage > 100) {
      this.props.setErrorMessage(
        this.props.t("DISCOUNT_VALUE_RESTRICTION"),
        false,
      );
      this.setState({ loading: false });
    }
  };

  removePSFromCart = (val) => {
    if (val) {
      this.setState({ loading: true });
      var payload = {};
      var url = `${constants.busV44UrlPublic}/quote/${this.state.id}`;
      payload = {
        quoteItem: [{ ...this.state.itemToRemove }],
      };
      payload.quoteItem[0].action = "DELETE";
      payload.action = "EDIT_QUOTE";
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      BusApiCall("PATCH", url, payload)
        .then((res) => {
          if (res.data) {
            this.setState({
              removeItemWrning: false,
              itemToRemove: {},
            });
            this.getQuoteData(this.state.id);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            removeItemWrning: false,
            itemToRemove: {},
          });
        });
    } else {
      this.setState({
        loading: false,
        removeItemWrning: false,
        itemToRemove: {},
      });
    }
  };

  showRemoveItemWarning = (item) => {
    this.setState({
      itemToRemove: item,
      removeItemWrning: true,
    });
  };

  reviseOffering = (item) => {
    var data = {
      productQuoted: item.productOffering,
      quotedCustomer: this.state.customerDetails,
      relatedParty: this.state.quoteData[0].relatedParty[0],
      quoteData: {
        quoteId: item.id,
        quoteIndex: item.index,
      },
      originalQuoteId: this.state.id,
      nonEditableItem: item.editable === false ? true : false,
    };
    if (this.state.quoteData[0].type !== "NewActivation") {
      data.userData = this.state.quoteData[0].userData;
      data.type = this.state.quoteData[0].type;
    }
    this.props.router.navigate("/newOrder/" + item.productOffering.id, data);
  };

  showSubscriptionIds = () => {
    console.log("show subscription ids");
  };
  openCancelDialog = () => {
    this.setState({ isCancelQuote: true });
  };
  closeCancelDialog = () => {
    this.setState({ isCancelQuote: false });
  };

  setStateListChange = (country) => {
    this.setState({
      loading: true,
    });
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    getStatesList(country, jsonData)
      .then((res) => {
        this.setState({
          statesList: res,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("FAILED_TO_LOAD_STATES"),
            false,
          );
        }
      });
  };

  onChangeBanDetails = (e) => {
    var tempCustomer = { ...this.state.leadCustomerDetails };
    var tempBan = tempCustomer.banDetails;
    tempBan[e.target.name] = e.target.value;
    tempCustomer.banDetails = tempBan;
    this.setState({
      leadCustomerDetails: tempCustomer,
    });
  };
  onChangeContactDetails = (e) => {
    var tempCustomer = { ...this.state.leadCustomerDetails };
    var tempContact = tempCustomer.contact;
    tempContact[e.target.name] = e.target.value;
    tempCustomer.contact = tempContact;
    this.setState({
      leadCustomerDetails: tempCustomer,
    });
  };
  onChangeShippingDetails = (e) => {
    var tempCustomer = { ...this.state.leadCustomerDetails };
    var tempShipping = tempCustomer.shipping;
    tempShipping[e.target.name] = e.target.value;
    tempCustomer.shipping = tempShipping;
    this.setState({
      leadCustomerDetails: tempCustomer,
    });
  };

  render() {
    // const sideMenu = JSON.parse(localStorage.getItem('sideMenu'));
    const sideMenu = this.props.sideMenu;
    const t = this.props.t;
    const customerData = { ...this.state.customerDetails };
    const { error, success } = this.state;
    const { classes: jssClasses } = this.props;
    return (
      <div style={sideMenu ? {} : { position: "relative" }}>
        <div className={"newContentWrapper"}>
          <div className={"breadcrumbWrapper"}>
            <div className={"breadcrumbContent"}>
              <Grid container>
                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Breadcrumb list={this.state.bread} />
                  {this.state.quoteData && this.state.quoteData.length > 0 && (
                    <div className={"bottomBreadcrumbText"}>
                      <div
                        style={{
                          display: "flex",
                          gap: ".5rem",
                          alignItems: "center",
                        }}
                      >
                        {this.state.quoteData[0].typeDescription &&
                          this.state.quoteData[0].typeDescription !== "" && (
                            <h2
                              style={{
                                fontSize: "15px",
                                marginBottom: 0,
                                fontWeight: "bold",
                              }}
                            >
                              {this.props.t("TYPE")}:{" "}
                              {this.state.quoteData[0].typeDescription}
                            </h2>
                          )}
                        {this.props.router.location.pathname === "/quote/:id" &&
                          this.state.quoteData[0].subscriptionId ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                gap: "1rem",
                                alignItems: "end",
                              }}
                            >
                              <h2
                                style={{
                                  fontSize: "15px",
                                  marginBottom: 0,
                                  fontWeight: "bold",
                                  display: "inherit",
                                }}
                              >
                                {/* {this.props.t('STATUS')}: */}

                                {/* {` ${this.state.quoteData[0].typeDescription} (${this.state.quoteData[0].subscriptionId}) has been`}&nbsp; */}
                                {/* {` ${this.state.quoteData[0].typeDescription} has been`}&nbsp;
                                                            {this.state.quoteData[0].quoteStatusDescription} */}
                                <Chip
                                  size="normal"
                                  className="inProgressChip"
                                  label={
                                    this.state.quoteData[0]
                                      .quoteStatusDescription
                                  }
                                />

                                {/* <br/>
                                                            {this.props.t('SUBSCRIPTION_IDS')}: {this.state.quoteData[0].subscriptionId} */}
                              </h2>
                              <Tooltip title={t("VIEW_SUBSCRIPTION_IDS")}>
                                {/* <VisibilityIcon onClick={() => this.setState({ toggelSubscriptionIdDialog: true })}
                                                                    style={{ marginLeft: '10px', position: 'relative', top: '-2px' }}
                                                                /> */}
                                <IconButton
                                  className="buttonSecondary"
                                  onClick={() =>
                                    this.setState({
                                      toggelSubscriptionIdDialog: true,
                                    })
                                  }
                                >
                                  <ViewIconNew />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </>
                        ) : (
                          <>
                            <h2
                              style={{
                                fontSize: "15px",
                                marginBottom: 0,
                                fontWeight: "bold",
                              }}
                            >
                              {/* {this.props.t('STATUS')}: {this.props.t('NEW_ACTIVATION')} has been {this.state.quoteData[0].quoteStatusDescription} */}
                              {/* {this.props.t('STATUS')}: {this.state.quoteData[0].quoteStatusDescription} */}
                              {this.state.quoteData[0]
                                .quoteStatusDescription && (
                                  <Chip
                                    size="normal"
                                    className="inProgressChip"
                                    label={
                                      this.state.quoteData[0]
                                        .quoteStatusDescription
                                    }
                                  />
                                )}
                            </h2>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </Grid>
                {this.state.toggelSubscriptionIdDialog && (
                  <Dialog
                    disableScrollLock={true}
                    maxWidth={"sm"}
                    PaperComponent={this.draggableDialogPaper}
                    fullWidth={true}
                    open={this.state.toggelSubscriptionIdDialog}
                    aria-labelledby="delete-dialog-title"
                    PaperProps={
                      {
                        // className: jssClasses.resizablePaper
                      }
                    }
                  >
                    <DialogTitle
                      id="draggableDialogPaper"
                      style={{ cursor: "move" }}
                    >
                      <div style={{ display: "flex" }}>
                        <span style={{ display: "inline-flex", width: "95%" }}>
                          {t("SUBSCRIPTION_IDS")}
                        </span>
                        <Tooltip title={t("CLOSE")}>
                          <IconButton
                            onTouchStart={() =>
                              this.setState({
                                toggelSubscriptionIdDialog: false,
                              })
                            }
                            onClick={() =>
                              this.setState({
                                toggelSubscriptionIdDialog: false,
                              })
                            }
                            aria-label="close"
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </DialogTitle>
                    <DialogContent dividers>
                      {this.state.quoteData[0].subscriptionId
                        .split(",")
                        .map((item, index) => (
                          <DialogContentText key={index}>
                            {item}
                            <br />
                          </DialogContentText>
                        ))}
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={(event) =>
                          this.setState({ toggelSubscriptionIdDialog: false })
                        }
                        color="primary"
                      >
                        {t("CLOSE")}
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}
                <Grid
                  item
                  style={{ textAlign: "right" }}
                  size={{
                    xs: 6,
                  }}
                >
                  {(this.props.loggedInUserType === "SALES_MANAGER" ||
                    this.props.loggedInUserType === "SALES_REPRESENTATIVE") &&
                    this.state.quoteData &&
                    this.state.quoteData.length > 0 &&
                    this.state.quoteData[0].quoteStatus !== "QUO_ORDERED" &&
                    this.state.quoteData[0].quoteStatus !== "QUO_CANCELLED" &&
                    // <Button onClick={() => { this.openCancelDialog() }}>
                    //     <span><ClearIcon /></span>
                    //     {t('CANCEL_QUOTE')}
                    // </Button>
                    // <Tooltip title={t('CANCEL_QUOTE')}>
                    //     <IconButton
                    //         onClick={() => { this.openCancelDialog() }}
                    //         className={'orderActionsIcon'}
                    //     >
                    //         <CancelIcon />
                    //         <label style={{ color: this.props.color }}>{t('CANCEL_QUOTE')}</label>
                    //     </IconButton>
                    // </Tooltip>
                    ""}

                  {this.state.workFlowEnabled &&
                    this.state.processInstanceDiagram &&
                    this.props.providerType === "SALES_CHNL_PROVIDER" && (
                      <Tooltip title={t("DIAGRAM")}>
                        <IconButton
                          onClick={() => {
                            this.openDiagramDialog();
                          }}
                          className={"orderActionsIcon"}
                        >
                          <DiagramIcon />
                          {/* <label style={{ color: this.props.color }}>
                            {t("DIAGRAM")}
                          </label> */}
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
              </Grid>
            </div>
          </div>

          <main
            ref={this.myRef}
            style={sideMenu ? {} : { maxWidth: "1300px" }}
            className={sideMenu ? "" : ""}
          >
            {this.state.render && (
              <>
                <div style={{ marginTop: sideMenu ? "25px" : "120px" }}>
                  <CustomerDetailBlock
                    editOption={false}
                    edit={() => { }}
                    customerDetails={this.state.customerDetails}
                  />
                </div>
                {this.state.renderCartBlock && (
                  <div style={{ marginTop: sideMenu ? "25px" : "25px" }}>
                    <NewCartBlock
                      cartData={this.state.quoteData}
                      showRemoveItemWarning={this.showRemoveItemWarning}
                      changeQuantity={this.changePSQuantity}
                      tempChangePSQuantity={this.tempChangePSQuantity}
                      tempChangePSQuantityVerify={
                        this.tempChangePSQuantityVerify
                      }
                      changePSQuantity={this.changePSQuantity}
                      changePSDiscount={this.changePSDiscount}
                      changePSDiscountValue={this.changePSDiscountValue}
                      discountPercentage={this.state.discountPercentage}
                      edit={this.state.editItems}
                      providerType={this.props.providerType}
                      loggedInUserType={this.props.loggedInUserType}
                      type={this.state.quoteType}
                      orderCustomer={this.state.customerDetails}
                      updateLineItemClient={this.updateLineItemClient}
                      reviseOffering={this.reviseOffering}
                      screen={"quote"}
                      editOptions={this.state.editOptions}
                      comments={this.state.comments}
                      notes={this.state.notes}
                      changeNotes={this.changeNotes}
                      confirmQuote={this.confirmQuote}
                      addOfferings={this.addOfferings}

                    // discountPercentage={this.state.discountPercentage}
                    />
                  </div>
                )}
                {/* {this.state.quoteType && this.state.quoteType === 'ShiftSubscription' && */}
                {this.state.quoteData &&
                  this.state.quoteData.length > 0 &&
                  this.state.quoteData[0].quoteStatus !== "QUO_APPROVED" &&
                  this.state.quoteData[0].quoteStatus !== "QUO_ORDERED" &&
                  this.state.quoteData[0].quoteStatus !== "QUO_REVIEW" &&
                  this.state.quoteData[0].quoteStatus !== "QUO_WAIT_ORDER" && (
                    <div style={{ marginTop: "25px" }}>
                      <Grid container spacing={1}>
                        <Grid
                          item
                          align="right"
                          size={{
                            xs: 12,
                            md: 8,
                          }}
                        >
                          <Button
                            onClick={() => {
                              this.addOfferings();
                            }}
                          >
                            <span
                              style={{
                                verticalAlign: "middle",
                                marginRight: ".25rem",
                              }}
                            >
                              <PlusIcon />
                            </span>
                            {t("ADD_OFFERINGS")}
                          </Button>
                          <Button
                            onClick={() => {
                              this.updateQuoteData();
                            }}
                            disabled={!this.state.unsavedChanges}
                            style={{ marginLeft: "15px", marginRight: "4px" }}
                          >
                            {t("UPDATE_QUOTE")}
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                {/* } */}

                {this.state.quoteHistory &&
                  this.state.quoteHistory.length > 0 && (
                    <div style={{ margin: "25px 0" }}>
                      <h3>
                        {this.props.t("QUOTE_STATUS_HISTORY")}
                        <Tooltip title={this.props.t("REFRESH_QUOTE_HISTORY")}>
                          <IconButton
                            className="iconButtonSecondary"
                            onClick={() => {
                              this.setState({ loading: true });
                              this.getQuoteData(this.state.id);
                            }}
                            style={{ float: "right" }}
                          >
                            <RefreshIcon />
                          </IconButton>
                        </Tooltip>
                      </h3>
                      <Card variant="outlined" style={{ borderRadius: "8px" }}>
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ width: "20%" }}>
                                  {this.props.t("DATE")}
                                </TableCell>
                                <TableCell style={{ width: "30%" }}>
                                  {this.props.t("STATUS_CHANGE")}
                                </TableCell>
                                <TableCell style={{ width: "50%" }}>
                                  {this.props.t("ADDITIONAL_INFO")}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.is_order_status && (
                                <TableRow>
                                  <TableCell>
                                    {formatDate(
                                      this.state.order_status_details
                                        .statusChangeTime,
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    <u
                                      onClick={() => {
                                        this.showActionDialog();
                                      }}
                                      style={{ cursor: "pointer" }}
                                      //  className='activeLink'
                                      className="button"
                                    >
                                      {
                                        this.state.order_status_details
                                          .status_text
                                      }
                                    </u>
                                  </TableCell>
                                  <TableCell>
                                    {this.state.order_status_details
                                      .status_description &&
                                      this.state.order_status_details.status_description
                                        .split("\n")
                                        .map((item, index) => (
                                          <React.Fragment key={index}>
                                            {item}
                                            <br />
                                          </React.Fragment>
                                        ))}
                                  </TableCell>
                                </TableRow>
                              )}
                              {this.state.quoteHistory.map((item, index) => (
                                <>
                                  <TableRow key={index}>
                                    <TableCell>
                                      {formatDate(
                                        item.statusDatetime,
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {index === 0 &&
                                        this.state.formFields &&
                                        this.state.formFields.fields &&
                                        this.state.formFields.fields.length > 0 &&
                                        this.state.isEligibleUser ? (
                                        <u
                                          onClick={() => {
                                            this.showActionDialog();
                                          }}
                                          style={{ cursor: "pointer" }}
                                          //  className='activeLink'
                                          className="button"
                                        >
                                          {item.quoteStatus}
                                        </u>
                                      ) : (
                                        item.quoteStatus
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {/* {index === 0 ?
                                                                    <>
                                                                        {this.state.eligibleRole ?
                                                                            <>
                                                                                {this.state.eligibleRole ? 'Waiting for ' + this.state.eligibleRole + ' action' : ''}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {item.changeReason &&
                                                                                    item.changeReason.split('\\n').map((item, index) => (
                                                                                        <React.Fragment key={index}>
                                                                                            {item.includes('<a ') ?
                                                                                                <div dangerouslySetInnerHTML={{ __html: item }} />
                                                                                                :
                                                                                                <>
                                                                                                    {item}
                                                                                                    <br />
                                                                                                </>
                                                                                            }
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                            </>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {item.changeReason &&
                                                                            item.changeReason.split('\\n').map((item, index) => (
                                                                                <React.Fragment key={index}>
                                                                                    {item}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            ))}
                                                                    </>
                                                                } */}
                                      <>
                                        {item.changeReason && (
                                          <React.Fragment key={index}>
                                            {item.changeReason.includes(
                                              "<a ",
                                            ) ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: item.changeReason,
                                                }}
                                              />
                                            ) : (
                                              <>
                                                {item.changeReason
                                                  .split("\\n")
                                                  .map((item, index) => (
                                                    <React.Fragment key={index}>
                                                      {item}
                                                      <br />
                                                    </React.Fragment>
                                                  ))}
                                              </>
                                            )}
                                          </React.Fragment>
                                        )}
                                      </>
                                    </TableCell>
                                  </TableRow>
                                </>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </div>
                  )}

                {this.state.comments &&
                  this.state.comments.length > 0 &&
                  !this.props.priceSummaryView && (
                    <div style={{ margin: "25px 0" }}>
                      <h3>{this.props.t("NOTES")}</h3>
                      <Card variant="outlined" style={{ borderRadius: "8px" }}>
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ width: "220px" }}>
                                  {this.props.t("DATE")}
                                </TableCell>
                                <TableCell>{this.props.t("COMMENT")}</TableCell>
                                <TableCell style={{ width: "200px" }}>
                                  {this.props.t("BY")}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.comments.map((comment, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {formatDate(comment.dateTime)}
                                  </TableCell>
                                  <TableCell>
                                    <React.Fragment key={index}>
                                      {comment.text.includes("<a ") ? (
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: comment.text,
                                          }}
                                        />
                                      ) : (
                                        <>{comment.text}</>
                                      )}
                                    </React.Fragment>
                                  </TableCell>
                                  <TableCell>{comment.addedBy}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Card>
                    </div>
                  )}

                {/* {this.props.loggedInUserType === "SALES_MANAGER" || this.props.userPerms.includes("CUMULATOR-QUOTE_UPDATE") ?
                                <>
                                    {this.state.quoteData && this.state.quoteData.length > 0 && this.state.quoteData[0].quoteStatus === 'QUO_REVIEW' &&
                                        <div>
                                            <div style={{ margin: '25px 0' }}>
                                                <Input
                                                    size={'small'}
                                                    name={'notes'}
                                                    variant={'outlined'}
                                                    placeholder={this.props.t('NOTES') + '.......'}
                                                    //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                                    value={this.state.notes}
                                                    onChange={this.changeNotes}
                                                    //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                                    inputProps={{ multiline: true, rows: 5, cols: 10, disabled: false }}
                                                />
                                            </div>
                                            <div align="right" style={{ margin: '25px 0' }}>
                                                <Button onClick={() => { this.verifyQuote('QUO_REJECTED') }} style={{ marginRight: '15px' }}>{this.props.t('REJECT')}</Button>
                                                <Button onClick={() => { this.verifyQuote('QUO_APPROVED') }}>{this.props.t('APPROVE')}</Button>
                                            </div>
                                        </div>
                                    }
                                    {this.state.quoteData && this.state.quoteData.length > 0 && this.state.quoteData[0].quoteStatus === 'QUO_APPROVED' &&
                                        <>
                                            <div style={{ margin: '25px 0' }}>
                                                <div>
                                                    <Input
                                                        size={'small'}
                                                        name={'notes'}
                                                        variant={'outlined'}
                                                        placeholder={this.props.t('NOTES') + '.......'}
                                                        //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                                                        value={this.state.notes}
                                                        onChange={this.changeNotes}
                                                        //inputProps={{ rows: "5", cols: "10", disabled: true }}
                                                        inputProps={{ multiline: true, rows: 5, cols: 10, disabled: false }}
                                                    />
                                                </div>
                                            </div>
                                            <div align="right" style={{ margin: '25px 0' }}>
                                                <Button onClick={() => { this.verifyQuote('QUO_REJECTED') }} style={{ marginRight: '15px' }}>{this.props.t('REJECT')}</Button>
                                                <Button onClick={() => { this.createOrder() }}>{t('CREATE_ORDER')}</Button>
                                            </div>
                                        </>
                                    }
                                </>
                                :
                                ''
                            } */}
                {this.state.quoteData &&
                  this.state.quoteData.length > 0 &&
                  this.state.quoteData[0].quoteStatus !== "QUO_APPROVED" &&
                  !this.props.priceSummaryView &&
                  this.state.quoteData[0].quoteStatus !== "QUO_ORDERED" && (
                    <>
                      <div style={{ margin: "25px 0" }}>
                        <div>
                          <Input
                            size={"small"}
                            name={"notes"}
                            variant={"outlined"}
                            placeholder={this.props.t("NOTES") + "......."}
                            //label={<Label label={props.t('NOTES')} edit={props.edit} stage={props.stage}/>}
                            value={this.state.notes}
                            onChange={this.changeNotes}
                            //inputProps={{ rows: "5", cols: "10", disabled: true }}
                            inputProps={{
                              multiline: true,
                              rows: 5,
                              cols: 10,
                              disabled: false,
                            }}
                          />
                        </div>
                      </div>
                      <div align="right" style={{ margin: "25px 0" }}>
                        {this.state.quoteData[0].quoteStatus !== "QUO_REVIEW" &&
                          this.state.quoteData[0].quoteStatus !==
                          "QUO_APPROVED" &&
                          this.state.quoteData[0].quoteStatus !==
                          "QUO_ORDERED" &&
                          this.state.quoteData[0].quoteStatus !==
                          "QUO_WAIT_ORDER" && (
                            <Button
                              onClick={() => {
                                this.showClearCartWarning();
                              }}
                              style={{ marginRight: "15px" }}
                            >
                              {t("CANCEL_QUOTE")}
                            </Button>
                          )}
                        <Button
                          onClick={() => {
                            this.confirmQuote(true);
                          }}
                        >
                          {t("ADD_NOTE")}
                        </Button>
                      </div>
                    </>
                  )}
                <div align="left">
                  {this.state.quoteData[0].quoteStatus !== "QUO_REVIEW" &&
                    this.state.quoteData[0].quoteStatus !== "QUO_APPROVED" &&
                    this.props.priceSummaryView &&
                    this.state.quoteData[0].quoteStatus !== "QUO_ORDERED" &&
                    this.state.quoteData[0].quoteStatus !==
                    "QUO_WAIT_ORDER" && (
                      <Button
                        onClick={() => {
                          this.showClearCartWarning();
                        }}
                      >
                        {t("CANCEL_QUOTE")}
                      </Button>
                    )}
                </div>
              </>
            )}
          </main>
        </div>
        {this.state.showClearWarning && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            PaperComponent={this.draggableDialogPaper}
            fullWidth={true}
            open={this.state.showClearWarning}
            aria-labelledby="delete-dialog-title"
            PaperProps={
              {
                // className: jssClasses.resizablePaper
              }
            }
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("CANCEL_QUOTE")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.showClearCartWarning()}
                    onClick={() => this.showClearCartWarning()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                {t("CANCEL_QUOTE_CONFIRMATION", { customerData })}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => this.showClearCartWarning()}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.clearQuoteData(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.removeItemWrning && (
          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            PaperComponent={this.draggableDialogPaper}
            fullWidth={true}
            open={this.state.removeItemWrning}
            aria-labelledby="delete-dialog-title"
            PaperProps={
              {
                // className: jssClasses.resizablePaper
              }
            }
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("REMOVE")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.removePSFromCart(false)}
                    onClick={() => this.removePSFromCart(false)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                {t("REMOVE_ITEM_CONFIRMATION")}
                {this.state.itemToRemove.productOffering
                  ? this.state.itemToRemove.productOffering.name + "?"
                  : "?"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => this.removePSFromCart(false)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.removePSFromCart(true)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.formFields &&
          this.state.formFields.fields &&
          this.state.formFields.fields.length > 0 &&
          this.state.actionDialog && (
            <OrderActionDialog
              data={this.state.formFields}
              open={this.state.actionDialog}
              close={this.closeActionDialog}
              bpmnProcessInstanceId={this.state.bpmnProcessInstanceId}
            />
          )}
        {this.state.showBanDialog && (
          <Dialog
            maxWidth={"md"}
            PaperComponent={this.draggableDialogPaper}
            fullWidth={true}
            open={this.state.showBanDialog}
            aria-labelledby="delete-dialog-title"
          >
            <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {this.state.customerDetails.accountName} {t("BAN_REQUIRED")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onClick={() => this.closeBanDialog()}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              {/* leadCustomerDetails */}
              <Grid container spacing={3}>
                <Grid
                  item
                  size={{
                    xs: 6,
                  }}
                >
                  <Input
                    error={!!error.ban}
                    size={"small"}
                    name={"ban"}
                    variant={"outlined"}
                    placeholder={this.props.t("CUSTOMER_BAN") + " *"}
                    value={this.state.leadCustomerDetails.banDetails.ban}
                    // onChange={this.changeCustomerBan}
                    onChange={(event) => {
                      this.onChangeBanDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          ban: "",
                        },
                      });
                    }}
                    helperText={
                      error.ban
                        ? error.ban
                        : this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                        " " +
                        this.state.quoteData[0].customer.tempCustCodePrefix
                    }
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.accountName}
                    helperText={error.accountName}
                    variant={"outlined"}
                    name={"accountName"}
                    size={"small"}
                    value={
                      this.state.leadCustomerDetails.banDetails.accountName
                    }
                    placeholder={t("ACCOUNT_NAME") + " *"}
                    onChange={(event) => {
                      this.onChangeBanDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          accountName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                {/* Contact / Authorised personal */}
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <h3>{t("CONTACT_DETAILS")} </h3>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.firstName}
                    helperText={error.firstName}
                    size={"small"}
                    variant={"outlined"}
                    name={"firstName"}
                    value={this.state.leadCustomerDetails.contact.firstName}
                    placeholder={t("FIRST_NAME")}
                    onChange={(event) => {
                      this.onChangeContactDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          firstName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.lastName}
                    helperText={error.lastName}
                    size={"small"}
                    variant={"outlined"}
                    name={"lastName"}
                    value={this.state.leadCustomerDetails.contact.lastName}
                    placeholder={t("LAST_NAME")}
                    onChange={(event) => {
                      this.onChangeContactDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          lastName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    // inputClass={classes.inputClass}
                    error={!!error.officePhone}
                    helperText={error.officePhone}
                    variant={"outlined"}
                    name={"officePhone"}
                    size={"small"}
                    value={this.state.leadCustomerDetails.contact.officePhone}
                    placeholder={t("OFFICE_PHONE")}
                    onChange={(event) => {
                      this.onChangeContactDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          officePhone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    // inputClass={classes.inputClass}
                    error={!!error.mobilePhone}
                    helperText={error.mobilePhone}
                    variant={"outlined"}
                    name={"mobilePhone"}
                    size={"small"}
                    placeholder={t("MOBILE_PHONE")}
                    value={this.state.leadCustomerDetails.contact.mobilePhone}
                    onChange={(event) => {
                      this.onChangeContactDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          mobilePhone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.email}
                    helperText={error.email}
                    variant={"outlined"}
                    name={"email"}
                    size={"small"}
                    value={this.state.leadCustomerDetails.contact.email}
                    placeholder={t("EMAIL") + " *"}
                    onChange={(event) => {
                      this.onChangeContactDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          email: "",
                        },
                      });
                    }}
                  />
                </Grid>
                {/* Shipping / business address */}
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <h3>{t("SHIPPING_ADDRESS")} </h3>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.attention}
                    helperText={error.attention}
                    size={"small"}
                    variant={"outlined"}
                    name={"attention"}
                    value={this.state.leadCustomerDetails.shipping.attention}
                    placeholder={t("ATTENTION") + " *"}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          attention: "",
                        },
                      });
                    }}
                  />
                </Grid>{" "}
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    error={!!error.phone}
                    helperText={error.phone}
                    size={"small"}
                    variant={"outlined"}
                    name={"phone"}
                    value={this.state.leadCustomerDetails.shipping.phone}
                    placeholder={t("PHONE")}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          phone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.street1}
                    helperText={error.street1}
                    size={"small"}
                    variant={"outlined"}
                    name={"street1"}
                    value={this.state.leadCustomerDetails.shipping.street1}
                    placeholder={t("STREET1") + " *"}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          street1: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    name={"street2"}
                    value={this.state.leadCustomerDetails.shipping.street2}
                    placeholder={t("STREET2")}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.city}
                    helperText={error.city}
                    name={"city"}
                    size={"small"}
                    variant={"outlined"}
                    value={this.state.leadCustomerDetails.shipping.city}
                    placeholder={t("CITY") + " *"}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          city: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.zip}
                    helperText={error.zip}
                    name={"zip"}
                    size={"small"}
                    variant={"outlined"}
                    value={this.state.leadCustomerDetails.shipping.zip}
                    placeholder={t("ZIP")}
                    onChange={(event) => {
                      this.onChangeShippingDetails(event);
                      // this.setState({
                      //     error: {
                      //         ...this.state.error,
                      //         zip: "",
                      //     },
                      // });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FormControl
                    variant={"outlined"}
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="country">{t("COUNTRY")} *</InputLabel>
                    <Select
                      native
                      label="COUNTRY"
                      value={this.state.leadCustomerDetails.shipping.country}
                      inputProps={{
                        name: "country",
                        id: "country",
                      }}
                      onChange={(event) => {
                        this.onChangeShippingDetails(event);
                        this.setStateListChange(event.target.value);
                      }}
                    >
                      {/* <option value="" disabled>Select Country *</option> */}
                      {/* {stateCode.country.map(a => (
                                                    <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                ))} */}
                      {this.props.countriesList.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FormControl
                    variant={"outlined"}
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="state">{t("STATE")} *</InputLabel>
                    <Select
                      native
                      label="STATE"
                      onChange={(event) => {
                        this.onChangeShippingDetails(event);
                        this.setState({
                          error: {
                            ...this.state.error,
                            state: "",
                          },
                        });
                      }}
                      value={this.state.leadCustomerDetails.shipping.state}
                      error={!!error.state}
                      helperText={error.state}
                      inputProps={{
                        name: "state",
                        id: "state",
                      }}
                    >
                      <option value="" disabled></option>
                      {/* {stateCode.state[this.state.shipping.country].map(a => (
                                                    <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                ))} */}
                      {this.state.statesList.map((a) => (
                        <option key={a.id} value={a.id}>
                          {" "}
                          {a.name}
                        </option>
                      ))}
                    </Select>
                    <FormHelperText style={{ color: "#f44336" }}>
                      {error.state}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    float: "left",
                    fontWeight: "bold",
                    color: "#f44336",
                  }}
                >
                  {this.state.showCustomerBanError &&
                    this.props.t("CUSTOMER_CODE_PREFIX_ERROR") +
                    " " +
                    this.state.quoteData[0].customer.tempCustCodePrefix}
                </div>
                <div style={{ float: "right" }}>
                  <Button
                    onClick={(event) => this.createCustomerBan()}
                    color="primary"
                  >
                    {t("SUBMIT")}
                  </Button>
                </div>
                <div style={{ clear: "both" }}></div>
              </div>
            </DialogActions>
          </Dialog>
        )}
        <Loader loading={this.state.loading} />
        <CancelOrderDialog
          screen={"quote"}
          isOpen={this.state.isCancelQuote}
          close={this.closeCancelDialog}
          orderId={this.state.id}
        />
      </div>
    );
  }
}

// const jssStyles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     }
// }

const mapStateToProps = (state) => {
  return {
    tenantId: state.auth.tenantId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    roles: state.auth.roles,
    permissions: state.auth.userPerms,
    providerName: state.auth.providerName,
    loggedInUserName: state.auth.loggedInUserName,
    loggedInUserId: state.auth.loggedInUserId,
    securityGroupsList: state.auth.securityGroupsList,
    userPerms: state.auth.userPerms,
    priceSummaryView: state.auth.priceSummaryView,
    accessToken: state.auth.access_token,
    shoppingQuote: state.quote.shoppingQuote,
    sideMenu: state.auth.sideMenu,
    countriesList: state.global.countriesList,
    defaultCountry: state.auth.defaultCountry,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setQuote: (data) => dispatch({ type: actionTypes.SET_QUOTE, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(VerifyQuote)));
